import type { CommonResponse, EmptyResponse } from '@/types/responseModel';
import type { Keyword, RelateQuery, ShadeDetail } from '@/types/visualization';
import { Request } from '@/utils/request';

import type { IAudioAlign } from './agent';

export function getKeywordList() {
  return Request<CommonResponse<Keyword>>({
    url: '/rest/os/biog/keyword/get',
    method: 'get'
  });
}

export function getShadeDetail(params: RelateQuery) {
  return Request<CommonResponse<ShadeDetail>>({
    url: '/rest/os/biog/shade/v2/detail',
    method: 'get',
    params
  });
}

export function getNewBiog() {
  return Request<CommonResponse<any>>({
    url: '/rest/os/biog/init',
    method: 'get'
  });
}

interface IAboutMeRes {
  selfIntroduction: string;
}

export function getAboutMe() {
  return Request<CommonResponse<IAboutMeRes>>({
    url: '/rest/os/user/settings/get',
    method: 'get'
  });
}

interface ISave {
  selfIntroduction: string;
}
export function saveIntroduction(data: ISave) {
  return Request<EmptyResponse>({
    url: '/rest/os/user/settings/introduction/save',
    method: 'post',
    data
  });
}

export interface IRankDetail {
  dayNum: number;
  memoryCount: number;
}

export function getRankDetail() {
  return Request<CommonResponse<IRankDetail>>({
    url: '/rest/os/user/level/detail',
    method: 'get'
  });
}

export interface IBriefIntroduction {
  id: number;
  briefIntroduction?: string;
  voiceUrl?: string;
  status: 'doing' | 'done' | 'error';
  errorMessage?: string;
  duration?: number;
  audioAlign?: IAudioAlign[];
}

export function getBriefIntroduction() {
  return Request<
    CommonResponse<{
      preconditions: { hasVoice: boolean; hasBio: boolean };
      briefIntroduction: IBriefIntroduction;
    }>
  >({
    url: '/rest/os/user/settings/brief/introduction/get',
    method: 'get'
  });
}

export function saveBriefIntroduction(data?: { briefIntroduction?: string }) {
  return Request<EmptyResponse>({
    url: '/rest/os/user/settings/brief/introduction/save',
    method: 'post',
    data
  });
}

export function generateBriefIntroduction() {
  return Request<CommonResponse<string>>({
    url: '/rest/os/user/settings/brief/introduction/generate',
    method: 'post'
  });
}
